import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { AlertService, Dialog } from '../alert.service';
import { APIService } from '../api.service';
//import { threadId } from 'worker_threads';
import { DataService } from '../data.service';
import { FunctionService } from '../function.service';
import { AnEvent, Draw, Entry, Player, Tornament } from '../Main.Model';
import {saveAs as importedSaveAs} from "file-saver";
import { MatTabChangeEvent } from '@angular/material/tabs';
import { animate, style, transition, trigger } from '@angular/animations';
import { Subject } from 'rxjs';


@Component({
    selector: 'app-torns',
    templateUrl: './torns.component.html',
    styleUrls: ['./torns.component.css'],
    animations: [
        trigger('fade', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('1000ms ease-out', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class TornsComponent implements OnInit {

  Days2Ago: Date;
  //SelectedDraw: Draw;
  SponsorURL?: String;
  SponsorImage?: String;
  LoggedInUserAlreadyEnteredInTorn?: Boolean;
  TableRows1?: number;
  TableRows2?: number;
  AllowTornUpdate?: Boolean;
  SelectedTab: String = "Players";
  showKO4PlayerOption?: Boolean
  Today: Date;
  MonthAgo: Date;
  SelectedPlayersEntry?: Entry;
  TornID?: number;
  SelectedPlayer?: Player;
  //showChangeTornDates: Boolean;
  //Directors: Player[];
  fileUrl?: string
  BackTo: String = 'Players';
  SelectedDrawChanged: boolean = false;  
  EventsEnteredArray: boolean[][] = [];
  isEditingPlayers: boolean = false;
  isEditingDraws: boolean = false;
  isEditingInfo: boolean = false;
  isEditingEvents: boolean = false;
  showSavedLabel: boolean[] = [];
  YESPressed: Subject<Dialog>;
  TornToDelete!: Tornament;
  TornFilter: string = '';

  constructor(public DataService: DataService, private FunctionService: FunctionService, private APIService: APIService, private AlertService: AlertService, private http: HttpClient) { 
    this.Today = new Date();
    this.Days2Ago = this.FunctionService.addDays(-2,this.Today)
    this.MonthAgo = this.FunctionService.addDays(-30,this.Today)
    this.Today = new Date();
    this.YESPressed = this.AlertService.YESPressed;
  }

  async ngOnInit() {
    if (!this.DataService.LoggedInUser || this.DataService.LoggedInUser.name == 'Login') {
      await this.DataService.LogUserInFromCookie();
    }
    //this.DataService.changeTornStatus('ChangeTorn');
    this.DataService.changeTornStatus('');
    if (!this.DataService.Torns) {
      this.DataService.refreshTorns();
    }

    this.YESPressed.subscribe( data => {
      this.YESButtonPressedOnDialog(data);
    })
    this.FunctionService.WhichTornsIsLoggedInUserIn();
  }

  updateEntryFeeStatus(entry: Entry) {
    //TODO: update entry fee status in backend
  }
  changeFilter(event: any) {
    if (this.TornFilter == event.target.innerText) {
      this.TornFilter = '';
    } else {
      this.TornFilter = event.target.innerText;
    }
    //change color of selected button:
    var buttons = document.querySelectorAll('.filter-button');
    if (this.TornFilter.indexOf('20') > -1) {//if date
      buttons.forEach(button => {
        if ((button as HTMLElement).innerText === this.TornFilter || (this.TornFilter != '' && (button as HTMLElement).innerText == event.target.innerText)) {
          button.classList.add('selected');
        } else {
          button.classList.remove('selected');
        }
      });
    } else {
      buttons.forEach(button => {
      if ((button as HTMLElement).innerText === this.TornFilter || (this.TornFilter != '' && (button as HTMLElement).innerText == event.target.innerText)) {
        button.classList.add('selected');
      } else {
        button.classList.remove('selected');
      }
    });
    }
    
  }

  editPlayers($event: Event) {
    this.isEditingPlayers = !this.isEditingPlayers;
    $event.stopPropagation();   // ⛔ stops tab change
  }

  editDraw(draw: Draw, $event: Event) {
    this.isEditingDraws = !this.isEditingDraws;
    $event.stopPropagation();   // ⛔ stops tab change

  }

  editInfo($event: Event) {
    this.isEditingInfo = !this.isEditingInfo;
    $event.stopPropagation();   // ⛔ stops tab change
  }

  editEvents($event: Event) {
    this.isEditingEvents = !this.isEditingEvents;
    $event.stopPropagation();   // ⛔ stops tab change
  }

  InitNewTorn() {
    this.DataService.newTorn = {
      id: 0,
      name: 'New Tournament',
      dateOfEvent: this.FunctionService.addDays(30, new Date()),
      endDateOfEvent: new Date(),
      closingDate: new Date(),
      lastUpdate: new Date(),
      directorId: 0,
      courts: 2,
      draws: [],
      entries: [],
      discount: 0,
      venueInfo: '',
      accomodationInfo: '',
      eventInfo: '',
      feeInfo: '',
      scheduleInfo: '',
      prizeGivingInfo: '',
      extraInfo:'',
      sponsorImage: '',
      sponsorURL: '',
      liveStreamURL: '',
      posterLocation: '',
      presetInfoSheet: '',
      doubles: 'Sunday',
      account: '',
      accountName: '',
      events: [],
      Director: undefined,
      AllowRepeat: false,
      Days2AfterStart: new Date(),
      Days2FromEndDate: new Date(),
      isTeams: false,
      SinglesPlayers: [],
      DoublesPlayers: [],
      MatchDuration: 60,
      UserEntered: false,
      Teams: []
    }
  // this.DataService.newTorn.dateOfEvent.setMinutes(0, 0, 0);
  // this.DataService.newTorn.endDateOfEvent.setMinutes(0, 0, 0);
  // this.DataService.newTorn.closingDate.setMinutes(0, 0, 0);
  }

  async addTorn() {
    if (this.DataService.LoggedInUser?.accessLevel! > 1) {
      this.InitNewTorn();
      this.AllowTornUpdate = true;
      this.DataService.newTorn!.id = await this.APIService.createNewTorn(this.DataService.newTorn)
      this.DataService.Torns?.push(this.DataService.newTorn!);
      this.DataService.SaveState();
    } else {
        alert("Cannot create Torn if you are not logged in!!!")
    }
  }

  get directors() {
    return this.DataService.Players?.filter(p => p.accessLevel! > 1);
  }
  

  async changeTheTorn(torn: Tornament) {
    this.DataService.SelectedDraw = null!;
    //this.ClearDraws();
    this.DataService.SelectedTorn = this.DataService.Torns?.find((t) => {return t.id == torn.id})!;
    //need to load Torn details:
    await this.RefreshTorn(this.DataService.SelectedTorn);
    this.SponsorURL = this.DataService.SelectedTorn!.sponsorURL;
    this.SponsorImage = this.DataService.SelectedTorn!.sponsorImage;
    //this.Totalentries = this.DataService.SelectedTorn.entries.length;
    //this.DataService.SelectedTorn.EditTeams = false;
    this.FunctionService.checkToSeeIfLoggedInUserIsInSelectedTorn();
    this.DataService.changeTornStatus('ShowTornDetails');
    this.SelectedTab = 'Players';
    
    // setTimeout(function () {
    //     this.$apply();
    // }, 500);
    //this.APIService.UserTrace.state = this.DataService.SelectedTorn.id;
    this.ShouldWeAllowUpdate();
    this.FunctionService.getDetailsFromEntry();
    if (!this.DataService.SelectedTorn!.MatchDuration) {
      this.DataService.SelectedTorn!.MatchDuration = 60;
    }

    console.log(this.directors.map(x => x.id));
    console.log(this.directors.find(x => x.id === this.DataService.SelectedTorn.directorId));

    this.DataService.SelectedDraw = this.DataService.SelectedTorn!.draws![0];
    this.DataService.selectedDrawIndex = 0;
    if (this.DataService.SelectedTorn!.isTeams == true) {
      this.DataService.SelectedTorn!.Teams = await this.APIService.getTeamsForTorn(this.DataService.SelectedTorn!.id);
      this.FunctionService.reCalcTeamTotals();
    }
  }

  // checkToSeeIfLoggedInUserIsInSelectedTorn() {
  //   this.LoggedInUserAlreadyEnteredInTorn = false;
  //   if (this.DataService.SelectedTorn && this.DataService.LoggedInUser) {
  //     if (this.DataService.SelectedTorn.entries) {
  //       for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
  //         if (this.DataService.LoggedInUser.id == this.DataService.SelectedTorn.entries[e].playerId) {
  //           this.LoggedInUserAlreadyEnteredInTorn = true;
  //           break;
  //         }
  //       }
  //     }
  //   }
  // }

  changeDatesOfTorn() {
    if (this.AllowTornUpdate == true) {
      this.AlertService.showDialog("update Torn", "Normal", null, null, "showChangeTornDates");
      //this.showChangeTornDates = true;
    }
  }

  async addNewDraw() {
    this.isEditingDraws = true;
    var newDraw = await this.FunctionService.addNewDraw(); //this will return a new draw with id
    // if (!newDraw || !newDraw.id || newDraw.id == 0) {
    //   this.AlertService.showSimpleAlert("Failed to create new draw with a valid ID");
    // }
    this.DataService.SelectedTorn!.draws?.push(newDraw);
    
    this.DataService.selectedDrawIndex = this.DataService.SelectedTorn!.draws!.length - 1;
    this.DataService.ChangeDraw(newDraw);
    //this.DataService.SelectedDraw = this.DataService.SelectedTorn.draws[this.DataService.selectedDrawIndex];
    this.isEditingDraws = false;
    //need to change tabs to new draw:
    // Select the newly added tab
    //this.selectedDrawIndex = this.DataService.SelectedTorn.draws.length - 1;
  }

  ChangeTheDraw(event: MatTabChangeEvent) {
    var draw = this.DataService.SelectedTorn!.draws![event.index];
    this.DataService.ChangeDraw(draw);
  }

  ShouldWeAllowUpdate() {
    this.AllowTornUpdate = false;
    if (this.DataService.SelectedTorn) {
        if (this.DataService.SelectedTorn.endDateOfEvent) {
          //this.DataService.SelectedTorn.Days2FromEndDate = this.FunctionService.add_days(this.DataService.SelectedTorn.endDateOfEvent,2);
            if (this.DataService.SelectedTorn.Days2FromEndDate! > this.Today || this.DataService.LoggedInUser?.accessLevel! > 2) {// || this.LoginState.AccessLevel > 2) {
                if (this.DataService.LoggedInUser?.accessLevel! > 1) {
                    this.AllowTornUpdate = true;
                }
            }
        }
    }
  }

  populateEventsPlayers(event: AnEvent) {
    event.Players = [];
    this.DataService.SelectedTorn?.entries?.forEach(entry => {
      if (entry.eventsList) {
        entry.eventsList.forEach(eventEntered => {
          if (eventEntered.id == event.id) {
            var BoolAlredyExists = false;
            event.Players?.forEach(dudes => {
              if (dudes.id == eventEntered.PartnerId) {
                BoolAlredyExists = true;
              }
            });
            if (BoolAlredyExists == false) {
              var PlayerObject = this.DataService.Players?.find((p) => p.id == entry.playerId);
              if (eventEntered.PartnerId! > 0) {
                var PartnerObject = this.DataService.Players?.find((p) => p.id == eventEntered.PartnerId);
                PlayerObject!.DoublesTotalPoints = PlayerObject?.doublesPoints! + PartnerObject?.doublesPoints!;
              //} else {
                //PlayerObject.Partner.name = ""
              }
              event.Players?.push(PlayerObject!);
            }
          }
        });
      }
    });
    //need to sort players by points:
    if (event.type == 'Doubles') {
      event.Players?.sort((a, b) => {
        if (a.DoublesTotalPoints! > b.DoublesTotalPoints!) {
          return -1
        }
        if (a.DoublesTotalPoints! < b.DoublesTotalPoints!) {
          return 1
        }
        return 0;
      })
    } else {
      event.Players.sort((a, b) => {
        if (a.singlesPoints! > b.singlesPoints!) {
          return -1
        }
        if (a.singlesPoints! < b.singlesPoints!) {
          return 1
        }
        return 0;
      })
    }
  }

  async RefreshTorn(Torn: any) {
    //will need to get copy of torns with entries, Draws & Events
    this.DataService.SelectedTorn = await this.APIService.PopulateTornArrays(Torn);

    this.FunctionService.convertEventsStringsIntoArray(this.DataService.SelectedTorn!);//need to update torns.entries.events to an array of event objects
 
    //this.DataService.SelectedTorn!.Days2AfterStart = this.FunctionService.addDays(2, this.DataService.SelectedTorn!.dateOfEvent)
    this.DataService.SelectedTorn!.Days2FromEndDate = this.FunctionService.addDays(2, this.DataService.SelectedTorn!.endDateOfEvent)
    //need to convert the dates to actual dates:
    //this.DataService.SelectedTorn!.dateOfEvent = this.DataService.SelectedTorn!.dateOfEvent?.substring(0, 10);
    this.DataService.SelectedTorn!.dateOfEvent = new Date(this.DataService.SelectedTorn!.dateOfEvent!);
    this.DataService.SelectedTorn!.endDateOfEvent = new Date(this.DataService.SelectedTorn!.endDateOfEvent!);
    this.DataService.SelectedTorn!.closingDate = new Date(this.DataService.SelectedTorn!.closingDate!);
    this.DataService.SelectedTorn!.eventDateString = this.DataService.SelectedTorn.dateOfEvent.toISOString().substring(0, 10);
    this.DataService.SelectedTorn!.eventEndDateString = this.DataService.SelectedTorn.endDateOfEvent.toISOString().substring(0, 10);
    this.DataService.SelectedTorn!.entryClosedDateString = this.DataService.SelectedTorn.closingDate.toISOString().substring(0, 10);
    if (!this.DataService.SelectedTorn) {
      this.AlertService.showSimpleAlert("Failure to populate torn arrays");
    }
    //need to populate Torn.entries.Events from Torn.Events & entries
    // this.DataService.SelectedTorn.entries.forEach(entry => {
    //   this.FunctionService.populateEventsEntered(entry);
    // });
    //need to populate Torn.Events.Players from entries
    this.DataService.SelectedTorn!.events?.forEach(_event => {
      this.populateEventsPlayers(_event);
      if (_event.type == 'Doubles') {
        _event.Players?.sort((a, b) => {
          if (a.DoublesTotalPoints! > b.DoublesTotalPoints!) {
            return -1
          }
          if (a.DoublesTotalPoints! < b.DoublesTotalPoints!) {
            return 1
          }
          return 0;
        })
      } else {
        _event.Players?.sort((a, b) => {
          if (a.singlesPoints! > b.singlesPoints!) {
            return -1
          }
          if (a.singlesPoints! < b.singlesPoints!) {
            return 1
          }
          return 0;
        })
      }
    });
    this.DataService.SelectedTorn!.Director = this.DataService.Players?.find((p) => p.id == this.DataService.SelectedTorn!.directorId);
    this.DataService.SelectedTorn!.draws?.forEach(draw => {
      this.DataService.SelectedTorn!.events?.forEach(theEvent => {
        if (draw.theEventID == theEvent.id) {
          draw.theEvent = theEvent
        }
      });
    });
    //need to populate EventsEnteredArray for the checkboxes - TODO these arrays will need to be bigger!!!!!!!!!!!
    this.EventsEnteredArray = Array.from({ length: 100 }, () =>
      Array.from({ length: 20 }, () => false)
    );
    this.DataService.SelectedTorn!.entries?.forEach((entry, index) => {
      entry.eventsList?.forEach(event => {
        //get index of event in torn.events:
        var EventIndex = this.DataService.SelectedTorn!.events?.findIndex((ev) => ev.id == event.id);
        if (EventIndex !== undefined && EventIndex > -1) {
          this.EventsEnteredArray[index][EventIndex] = true;
        }
      });
    });
  }

  EditEventsInEntry(EntryIndex: number, eventIndex: number, $event: any) {
    const isChecked = $event.target.checked;
    this.EventsEnteredArray[EntryIndex][eventIndex] = isChecked;
    var entry = this.DataService.SelectedTorn!.entries![EntryIndex];
    if (isChecked) {
      entry.eventsList?.push({...this.DataService.SelectedTorn!.events![eventIndex]});
    } else {
      var eventToRemove = this.DataService.SelectedTorn!.events![eventIndex];
      var EventPosInEntry = entry.eventsList?.findIndex((ev: any) => ev.id == eventToRemove.id);
      if (EventPosInEntry !== undefined && EventPosInEntry > -1) {
        entry.eventsList?.splice(EventPosInEntry, 1);
      }
    }
    this.APIService.updateEntry(entry);
  }

  BackToTorns() {
    this.DataService.changeTornStatus('ChangeTorn');
  }

  // changeTab(newTab) {
  //   this.SelectedTab = newTab;
  //   this.DataService.changeTornStatus('ChangeDraw');
  // }

  drawButtonColorDecide(draw: any) {
    var TheString = "";
    if (draw.theEvent) {
      if (draw.theEvent.type == 'Doubles' ) {
        TheString = TheString + "DoublesButton ";
      }
    } else {
      if (draw.type == 'Doubles' ) {
        TheString = TheString + "DoublesButton ";
      }
    }
    if (this.DataService.SelectedDraw) {
      if (this.DataService.SelectedDraw.id == draw.id) {
        TheString = TheString + "active";
      }
    }
    
    return TheString
  }

  showDraw(index: number) {
      //this.StartRefreshTimer();//disabled as no one really using phones any, plus was getting null error on game day
      this.DataService.ChangeDraw(this.DataService.SelectedTorn!.draws![index]);
      //this.DataService.SelectedDraw = this.DataService.SelectedTorn.draws[index];
      //this.changeTab('Draws');
      this.SelectedDrawChanged = true;
      //this.SelectedDrawChanged = false;
      
  }

  async addEvent() {
    this.isEditingEvents = true;
    var NewEvent = {
      id: 0,
      tornId: this.DataService.SelectedTorn!.id,
      name: '',
      type: 'Singles',
      cost: 0.0,
      minAge: 0,
      maxAge: 100,
      teams: false,
      Players: [],
      PartnerId: 0,
      Partner: {} as Player,
      Entered: false,
      updateNeeded: true,
      Good: false,
      Total: 0,
      DoublesTotalPoints: 0
    }
    if (!this.DataService.SelectedTorn!.events) {
        this.DataService.SelectedTorn!.events = [];
    }
    NewEvent.id = await this.APIService.createNewEvent(NewEvent);
    this.DataService.SelectedTorn!.events.push(NewEvent);
    //need to add new event to every entry as well!!!
    // this.DataService.SelectedTorn.entries.forEach(entry => {
    //   entry.events.push(NewEvent);
    // });
  }

  saveEvent(_event: any, eventIndex: number) {
    //_event.updateNeeded = false;
    //this.DataService.SelectedTorn.events.push(_event); //only happens for Create event!!!
    this.APIService.updateEvent(_event);
    this.showSavedLabel[eventIndex] = true;
    setTimeout(() => {
      this.showSavedLabel[eventIndex] = false;
    }, 5000); // 5 seconds
  }

  async deleteEvent(_event: any, i: number) {
    var Result = await this.APIService.deleteEvent(_event);
    if (Result == "Success") {
      this.DataService.SelectedTorn!.events?.splice(i, 1);
    }
   }

   editSettings() {
    this.DataService.changeTornStatus('Settings');
    this.SelectedTab = "";
   }

   UpdateTorn(torn: Tornament) {
      this.APIService.updateTorn(torn);
   }

   downloadInfosheet() {
    if (this.DataService.SelectedTorn.presetInfoSheet) {
      this.APIService.getFile(this.DataService.SelectedTorn.presetInfoSheet);
    } else {
        var TheTorn = this.DataService.SelectedTorn;
        var content = "Date of Event: " + TheTorn.dateOfEvent + "\n\nentries Close: " + TheTorn.closingDate + "\n\nVenue: " + TheTorn.venueInfo + "\n\nEvents: " + TheTorn.eventInfo + "\n\nAccomodation: " + TheTorn.accomodationInfo;
        content = content + "\n\nFees: " + TheTorn.feeInfo + "\n\nSchedules: " + TheTorn.scheduleInfo + "\n\nPrize Giving: " + TheTorn.prizeGivingInfo + "\n\nExtra: " + TheTorn.extraInfo;
        var blob = new Blob([content], { type: "text/plain;charset=utf-8" });
        var url = window.URL.createObjectURL(blob);
        importedSaveAs(blob, "InfoSheet.txt");
    }
   }

  //  DownloadEntryList() {
  //   if (this.DataService.SelectedTorn.entries) {
  //     if (this.DataService.SelectedTorn.entries.length > 0) {
  //       var content = "";
  //       var TheEntry = this.DataService.SelectedTorn.entries[0];
  //       for (let key in TheEntry) {//headings
  //           if (key != '$$hashKey' && key != 'TornamentObject' && key != 'id' && key != 'PlayerId' && key != 'PartnerId' && key != 'Tornament' && key != 'EventsEntered') {
  //               content = content + key + ',';
  //           }
  //       }
  //       content = content + '\n';
  //       for (var f = 0; f < this.DataService.SelectedTorn.entries.length; f++) {
  //           var entry = this.DataService.SelectedTorn.entries[f];
  //           for (let key in entry) {//data
  //               if (key != '$$hashKey' && key != 'TornamentObject' && key != 'id' && key != 'PlayerId' && key != 'PartnerId' && key != 'Tornament' && key != 'EventsEntered') {
  //                 if (key == 'events') {
  //                   var str = entry[key];
  //                   var newstr = str.replace(',','-');
  //                   newstr = newstr.replace(',','-');
  //                   newstr = newstr.replace(',','-');
  //                   entry[key] = newstr;
  //                 }
  //                 content = content + entry[key] + ',';
  //               }
  //           }
  //           content = content + '\n';
  //       }
  //       var blob = new Blob([content], { type: "text/plain;charset=utf-8" });
  //       importedSaveAs(blob, this.DataService.SelectedTorn.name + " entry list.csv");
  //     }
  //   }
  //  }

  Announce() {
    this.AlertService.showDialog("Email Announcement", "", null, "", "Announcements");

  }

   async DeleteTorn(torn: Tornament) {
    this.DataService.SelectedMatch = undefined; // in case the user was in the middle of editing match score
    //delete draw & matches & players links from DB
    this.TornToDelete = torn;
    var message = "";
    if (torn.draws?.length > 0) {
      //cycle through draws to see if there are matches
      message = message + "Draws"
      for (var d = 0; d < torn.draws.length; d++) {
        var draw = torn.draws[d];
        if (draw.Matches.length > 0) {
          message = message + ", Matches";
          break;
        }
      }
    }
    if (torn.entries?.length > 0) {
      message = message + ", Entries";
    }
    if (message != "") {
      message = " which has " + message;
    }
    this.AlertService.showDialog("Delete Torn", "YesNo", null, "Are you sure you want to delete " + torn.name + message + "?", "Standard");
   }

  async YESButtonPressedOnDialog(data: Dialog) {
    if (data.title == "Delete Torn") {
      if (this.TornToDelete.draws && this.TornToDelete.draws.length > 0) {
        for (var d = 0; d < this.TornToDelete.draws.length; d++) {
          var draw = this.TornToDelete.draws[d];
          if (draw.Matches && draw.Matches.length > 0) {
            for (var m = 0; m < draw.Matches.length; m++) {
              var match = draw.Matches[m];
              await this.APIService.deleteMatch(match);
            }
          }
          await this.APIService.deleteDraw(draw);
        }
      }
      if (this.TornToDelete.entries && this.TornToDelete.entries.length > 0) {
        for (var e = 0; e < this.TornToDelete.entries.length; e++) {
          var entry = this.TornToDelete.entries[e];
          await this.APIService.deleteEntry(entry);
        }
      }
      var Result = await this.APIService.deleteTorn(this.TornToDelete);
      if (Result){
        if (Result.statusCode == 200) {
          this.DataService.Torns.forEach((torn, index) => {
            if (torn.id == this.TornToDelete.id) {
              this.DataService.Torns.splice(index, 1);//remove from array
            }
          });
          //this.DataService.SelectedTorn = null;
          //this.DataService.changeTornStatus('ChangeTorn');
          this.DataService.SaveState();
        } else {
          this.AlertService.showSimpleAlert(Result.reasonPhrase);
        }
      }
    //} else if (data.title == "Delete Match") {

    }
  }

  //  AllowRepeatChanged() {

  //  }

   getPlayersEntry(PlayerId: number) {
    for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
      if (this.DataService.SelectedTorn.entries[e].playerId == PlayerId) {
          return this.DataService.SelectedTorn.entries[e];
      }
    }
   }

   showPlayersMatches(PlayerId: number, TornId: number) {
    this.SelectedPlayersEntry = this.getPlayersEntry(PlayerId);
    // if (this.DataService.Matches.length == 0) {
    //     this.GetMatchesRecords();
    // }
    this.TornID = TornId;
    this.SelectedPlayer = this.DataService.Players.find((p) => {return p.id == PlayerId})//getPlayerObject(PlayerId, this.DataService.Players);
    //this.StopRefreshTimer();
    this.DataService.changeTornStatus('PlayersMatches');
    this.DataService.changeMainStatus('Torns');
    this.BackTo = this.SelectedTab;
    this.SelectedTab = '';
    //update Match Winners:
    this.DataService.Matches.forEach(match => {
      if (match && match.torn == this.DataService.SelectedTorn.id) {
        this.FunctionService.UpdateWinnerOfMatch(match);
      }
    });
   }

   selectedEventForEntry?: AnEvent;

  //  addEventToEntry(entry, event) {
  //   // Implementation for adding an event to a player's entry
  //   if (event && !this.hasEvent(entry, event)) {
  //     event.Entered = true;
  //     entry.events.push(event);
  //     this.APIService.updateEntry(entry);
  //   }
  //  }

   hasEvent(entry: any, event: AnEvent) {
    entry.eventsList.forEach((ev: AnEvent) => {
      if (ev.id == event.id) {
        return true;
      }
    });
    return false;
   }

   EditEntries() {
    this.DataService.changeMainStatus('Torns');
      this.DataService.changeTornStatus('EditEntries');
      this.SelectedTab = '';
      //need to repopulate entries.Enets because event details such as age limit may have changed!!
      // this.DataService.SelectedTorn.entries.forEach(entry => {
      //   this.FunctionService.populateEventsEntered(entry);
      // });
      //need to calculate event totals and decide if good number or not
      this.FunctionService.RecalcEventTotals();
   }

   async addEventToPlayersEntry(entry: any, Theevent: AnEvent, $event: any) {
    entry.eventsList.push(Theevent);//add event to players entry
    if (Theevent.type == 'Doubles') {
      Theevent.PartnerId = 0;
      entry.DoublesMixed = $event.currentTarget.checked;
    } else {
      entry.Singles = $event.currentTarget.checked;
    }
    //Theevent.Entered = $event.currentTarget.checked;
    if ($event.currentTarget.checked == true) {
      entry.fee = entry.fee + Theevent.cost;
    } else {
      entry.fee = entry.fee - Theevent.cost!;
    }
    await this.FunctionService.RecalcEventTotals();//this will update the tick - as to if the number in the vent are good/bad... - DO before converting events string
    this.APIService.updateEntry(entry);
    //need to make sure new player is now available for all in the doubles selector...
  }

    clearPartner(entry: any, eventIndex: number) {
      var PartnersEntryFound = false;
      var ThePartnersId = entry.eventsList[eventIndex].PartnerId;
      entry.PartnerId = 0;
      //entry.Partner = "";
      entry.PartnerName = '';
      entry.eventsList[eventIndex].PartnerId = 0;
      entry.eventsList[eventIndex].PartnerName = '';
      //this.FunctionService.BuildEntryEvents(entry);
      this.APIService.updateEntry(entry);
      for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
          if (this.DataService.SelectedTorn.entries[e].playerId == ThePartnersId) {
              var TheEntry = this.DataService.SelectedTorn.entries[e];
              //TheEntry.PartnerId = 0;
              //TheEntry.Partner = "";
              //TheEntry.PartnerName = '';
              TheEntry.eventsList[eventIndex].PartnerId = 0;
              TheEntry.eventsList[eventIndex].Partner.name = '';
              //this.FunctionService.BuildEntryEvents(TheEntry);
              this.APIService.updateEntry(TheEntry);
              PartnersEntryFound = true;
          }
      }
      // if (PartnersEntryFound == false) {//if partner does not exist then remove anyway
      //     entry.PartnerId = 0;
      //     //entry.Partner = "";
      //     entry.PartnerName = '';
      //     this.APIService.updateEntry(entry);
      // }
      // setTimeout(function () {
      //     this.$apply();
      // }, 1000);
    }

    teamAssigned(entry: any) {
      this.APIService.updateEntry(entry);
    }

    filterEntry(entry: any) {
      if (entry.eventsList.length > 2) {
        return entry.eventsList[2].PartnerId == 0 || entry.eventsList[2].PartnerId == null;
      }
    }

    partnerAssigned(entry: any, TheEventId: number, Partner: any) {
      var EntryEvent = entry.eventsList.find((ev: AnEvent) => ev.id == TheEventId);
      EntryEvent.Partner = Partner;
      EntryEvent.PartnerId = Partner.id;
      var PartnerEntry = this.DataService.SelectedTorn.entries.find((ent) => ent.playerId == Partner.id);
      if (PartnerEntry) {
        var PartnersEvent = PartnerEntry.eventsList.find((ev: AnEvent) => ev.id == TheEventId)!;
        PartnersEvent.Partner = this.DataService.Players.find((p) => p.id == entry.playerId)!;
        PartnersEvent.PartnerId = entry.playerId;
        this.APIService.updateEntry(PartnerEntry);
      }

      this.FunctionService.RecalcEventTotals();
      this.FunctionService.CreatePlayersListForEachEvent();
      //this.FunctionService.BuildEntryEvents(entry)
      this.APIService.updateEntry(entry)
    }

    removePartner(entry: any, TheEventId: number) {
      if (this.DataService.LoggedInUser.accessLevel > 1) {//do not allow user to remove partners unless they are the Director or me
        var EntryEvent = entry.eventsList.find((ev: AnEvent) => ev.id == TheEventId)!;
        var ThePartnersId = EntryEvent.PartnerId;
        EntryEvent.Partner = null;
        EntryEvent.PartnerId = 0;
        var PartnerEntry = this.DataService.SelectedTorn.entries.find((ent) => ent.playerId == ThePartnersId)!;
        if (PartnerEntry) {
          var PartnersEvent = PartnerEntry.eventsList.find((ev: AnEvent) => ev.id == TheEventId)!;
          PartnersEvent.Partner = null!;
          PartnersEvent.PartnerId = 0;
          this.APIService.updateEntry(PartnerEntry);
        }

        this.FunctionService.RecalcEventTotals();
        this.FunctionService.CreatePlayersListForEachEvent();
        //this.FunctionService.BuildEntryEvents(entry)
        this.APIService.updateEntry(entry)
      }
    }

    ToggleFeesPaid(entry: any) {
      if (this.AllowTornUpdate == true) {
        if (entry.FeesPaid == true) {
            entry.FeesPaid = false;
        } else {
            entry.FeesPaid = true;
        }
        this.APIService.updateEntry(entry);
      } else {
        this.AlertService.showSimpleAlert("Torn is locked as it has already been played - therefore DB not updated");
      }
    }

  async deleteSelectedEntry(entry: any) {
    if (entry.PlayerId == this.DataService.LoggedInUser.id) {
      this.DataService.LoggedInUserAlreadyEnteredInTorn = false;
    }
    var Result = await this.APIService.deleteEntry(entry);
    if (Result.statusCode == 200) {
      //first remove from thier partner:
      // for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
      //   if (this.DataService.SelectedTorn.entries[e].PartnerId == entry.PlayerId) {
      //       this.DataService.SelectedTorn.entries[e].PartnerId = 0;
      //       this.DataService.SelectedTorn.entries[e].PartnerName = "";
      //   }
      // }
      //now remove from array
      for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
        if (this.DataService.SelectedTorn.entries[e].playerId == entry.playerId) {
            this.DataService.SelectedTorn.entries.splice(e, 1);
        }
      }
      //also remove from DoublesPlayers?
      for (var a = 0; a < this.DataService.SelectedTorn.DoublesPlayers.length; a++) {
        if (this.DataService.SelectedTorn.DoublesPlayers[a].id == entry.playerId) {
            this.DataService.SelectedTorn.DoublesPlayers.splice(a, 1);
        }
      }
      //also remove from SinglesPlayers?
      for (var a = 0; a < this.DataService.SelectedTorn.SinglesPlayers.length; a++) {
        if (this.DataService.SelectedTorn.SinglesPlayers[a].id == entry.playerId) {
            this.DataService.SelectedTorn.SinglesPlayers.splice(a, 1);
        }
      }
      this.FunctionService.RecalcEventTotals();
    }
  }

//   createEntryForPlayer(ThePlayer: any) {
//     var newEntry = {
//         dateOfEntry: new Date(),
//         name: ThePlayer.name,
//         singles: false,
//         doublesMixed: false,
//         Partner: "",
//         gender: ThePlayer.gender,
//         country: ThePlayer.country,
//         province: ThePlayer.province,
//         email: ThePlayer.email,
//         phone: ThePlayer.phone,
//         tornament: this.DataService.SelectedTorn.id,
//         playerId: ThePlayer.id,
//         PartnerId: 0,
//         partnerReq: false,
//         ttGrade: ThePlayer.tableTennis / 10,
//         badGrade: ThePlayer.badminton / 10,
//         sqGrade: ThePlayer.squash / 10,
//         tennisGrade: ThePlayer.tennis / 10,
//         feesPaid: false,
//         comments: '',
//         GradePrefer: 0,
//         Fee: 0,
//         DOB: ThePlayer.dOB,
//         id: 0,
//         singlesPoints: 0,
//         doublesPoints: 0,
//         fee: 0,
//         SendAnnouncement: false,
//         team: 0,
//         eventsString: '',
//         events: [],
//         YearsOld: 0
//     }
//     //newEntry.events = this.DataService.SelectedTorn.events.slice();
//     newEntry.events = [];//JSON.parse(JSON.stringify(this.DataService.SelectedTorn.events));
//     if (newEntry.gender == "M") {
//         newEntry.singlesPoints = (ThePlayer.TableTennis + ThePlayer.Badminton + ThePlayer.Squash + ThePlayer.Tennis) * 20;
//         newEntry.doublesPoints = (ThePlayer.TableTennis + ThePlayer.Badminton + ThePlayer.Squash + ThePlayer.Tennis) * 20;
//     } else {
//         newEntry.singlesPoints = (ThePlayer.TableTennis + ThePlayer.Badminton + ThePlayer.Squash + ThePlayer.Tennis) * 18;
//         newEntry.doublesPoints = (ThePlayer.TableTennis + ThePlayer.Badminton + ThePlayer.Squash + ThePlayer.Tennis) * 18;
//     }
//     //this.DataService.SelectedTorn.entries.splice(0, 0, newEntry);
//     //this.addNewEntry(newEntry, false, this.DataService.SelectedTorn.discount);
//     this.DataService.SaveState();
//     return newEntry
// }

  async addANewEntry() {
    //var PlayerList = document.getElementById("CreateEntryFromPlayer");
    var alreadyExists = false;
    for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
        if (this.DataService.SelectedTorn.entries[e].playerId == this.DataService.SelectedPlayer.id) {
            alreadyExists = true;
            break;
        }
    }
    //var ThePlayer = this.DataService.Players.find((p) => p.id == this.SelectedPlayer.id);//this.DataService.Players[PlayerList.selectedIndex];
    if (!alreadyExists) {
      var newEntry =  this.FunctionService.createEntryForPlayer(this.DataService.SelectedPlayer);
      newEntry.id = await this.APIService.createNewEntry(newEntry);
      newEntry.eventsList = [];//clear events as they get added on entry creation page
      if (newEntry.id > 0) {
        this.DataService.SelectedTorn.entries.push(newEntry);
      }
    }
  }

  addANewPerson() {
    this.DataService.changeMainStatus('NewUser');
  }

  TabChanged(event: MatTabChangeEvent) {
    if (event.index == 0) {//if Players selected
      //this.DataService.
    }
    if (event.index == 1 && this.DataService.SelectedDraw != null) {//if Draw selected
      this.DataService.selectedDrawIndex = 0;
      this.FunctionService.PopulateAvailablePlayersForSelectedDraw();
    }
    if (event.index == 3) {//if Events selected
      //populate Players in Events
      this.DataService.SelectedTorn!.events?.forEach(_event => {
        this.populateEventsPlayers(_event);
      });
    }
    if (event.index == 4) {//if Teams selected
      this.FunctionService.reCalcTeamTotals();
    }
  }

  Announcements() {
    this.AlertService.showDialog("Announcement", null, null, null, "Announcements");
  }

  Schedules() {
    this.DataService.changeTornStatus('Schedules');
  }

  printPage(draw: any) {
    var page: string = '';
        var CSS: string = '';
        if (draw.format == "KO") {
            page = 'newKO';
            CSS = 'KO';
        } else if (draw.format == "RR") {
            page = 'RR1';
            CSS = 'Print'
        } else if (draw.format == "PO") {
            page = 'POMatches';
            CSS = 'PO'
        }
        var contentToPrint = document.getElementById(page)!.innerHTML;
        var windowPopup = window.open('', '_blank', 'width=1000,height=800')!;
        windowPopup.document.open();
        windowPopup.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/CSS/' + CSS + '.CSS" /></head><body onload="window.print()">' + contentToPrint + '</body></html>');
        windowPopup.document.close();
        if (draw.format == "RR" && draw.NumberOfRRs > 1) {
            var contentToPrint = document.getElementById('RR2')!.innerHTML;
            var windowPopup = window.open('', '_blank', 'width=1000,height=800')!;
            windowPopup.document.open();
            windowPopup.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/CSS/Print.CSS" /></head><body onload="window.print()">' + contentToPrint + '</body></html>');
            windowPopup.document.close();
        }
  }

  showHistory(player: Player) {
    this.DataService.SelectedPlayer = player;
    this.DataService.changeMainStatus('History');
  }

  editPlayer(player: Player) {
    this.DataService.CurrentUser = player;
    this.DataService.changeMainStatus('UserMaintenance');
  }

  removeSelectedDrawFromSelectedTorn(draw: Draw) {
    //remove draw from torn:
    this.DataService.SelectedTorn.draws.forEach((draw, index) => {
      if (draw.id == this.DataService.SelectedDraw.id) {
        this.DataService.SelectedTorn.draws.splice(index, 1);//remove from array
      }
    });
    this.DataService.selectedDrawIndex = this.DataService.selectedDrawIndex - 1;
  }

  async deleteDraw () {
    var Result = await this.APIService.deleteDraw(this.DataService.SelectedDraw);
    if (Result != 'Success') {
        alert("draw did not delete as intended...");
    } else {
      this.DataService.SelectedDraw = null!;
    }

  }

  async DeleteCurrentDraw() {
    if (this.DataService.SelectedDraw.Matches && this.DataService.SelectedDraw.Matches.length > 0) {
      const confirmed = confirm("Are you sure you want to delete this draw? - it has matches linked to it that will still exist.");
      if (confirmed) {
        this.removeSelectedDrawFromSelectedTorn(this.DataService.SelectedDraw);
        this.FunctionService.deleteMatches();//delete all matches in draw first
        this.deleteDraw();
        
      }
    } else {
      this.removeSelectedDrawFromSelectedTorn(this.DataService.SelectedDraw);
      this.deleteDraw();
    }
  }

  // find the event for this specific player's entry
  entryEventFor(entry: Entry, eventId: number) {
    return entry.eventsList?.find(e => e.id === eventId);
  }

  getEventFor(entry: Entry, eventId: number) {
    return entry.eventsList?.find(e => e.id === eventId);
  }

  getEligiblePartners(eventId: number) {

    var PlayersInEvent: Player[] = [];
    this.DataService.SelectedTorn.entries.forEach(TornEntry => {
      var boolAlreadyExists = false;
      const otherEvent = TornEntry.eventsList?.find(e => e.id === eventId);
      if (otherEvent) {
        if (otherEvent.Partner) {//TornEntry already has a partner
          boolAlreadyExists = true;
        }
        this.DataService.SelectedTorn.entries.forEach(TornEntry2 => {
          if (TornEntry2.eventsList) {
            const otherEvent2 = TornEntry2.eventsList?.find(e => e.id === eventId);
            if (otherEvent2 && otherEvent2.Partner?.id == TornEntry.playerId) {//TornEntry2 is already partnered with TornEntry
              boolAlreadyExists = true;
            }
          }
        });
        if (boolAlreadyExists == false && otherEvent) {
          var PlayerObject = this.DataService.Players.find((p) => p.id == TornEntry.playerId)!;
          PlayersInEvent.push(PlayerObject);
        }
      }
    });
    return PlayersInEvent;
  }

  onPosterUpload(event: any) {
    this.DataService.SelectedTorn.posterLocation = "posters/" + event.target.files[0].name;
   }
  
}
